import React from "react";

const BuildMiiEmailSentModal = ({title,message, showEmailModal, onClick}) => {
    const handleCloseClick = () => {
        onClick(showEmailModal)
    }

    return (
        <div className="fixed z-10 inset-0 overflow-y-auto">
            <div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
            <div className="fixed inset-0 transition-opacity">
                <div className="absolute inset-0 bg-gray-500 opacity-75"></div>
            </div>
            <span className="hidden sm:inline-block sm:align-middle sm:h-screen"></span>
            <div className="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full">
                <div className="bg-white-700 px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
                </div>
                <div className="bg-white-700 px-4 py-3 sm:px-6 sm:flex sm:flex-col">
                <div className="flex flex-row  w-full justify-center p-5">
                    <span className="font-bold text-[1.5rem] p-5 text-center">{message}</span>
                </div>
                <div className="flex flex-row  w-full justify-center p-5">
                    <button className="bg-white-500 hover:bg-gray-300  border-[2px] border-themeColor-100 text-themeColor-200 font-bold py-2 px-4 rounded-full" onClick={handleCloseClick}>
                        Close
                    </button>
                </div>
                </div>
            </div>
            </div>
        </div>
    )
}

export default BuildMiiEmailSentModal